<ng-container>
    <mat-card
      class="icon-card"
      (mouseenter)="botonHabilitado && (hover = true)"
      (mouseleave)="botonHabilitado && (hover = false)"
      (click)="emitirEventosBotones()"
    >
      <img [src]="iconoActual" alt="icono" class="icon-img" />
      <div class="titulo-icono">{{ titulo }}</div>
    </mat-card>
  </ng-container>